import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { I18nProvider } from "./lib/i18n";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

if (new URLSearchParams(window.location.search).has("preview")) {
  // Copy preview for the hezo-ops editor (src/preview/). Loaded on demand, and
  // the check is inlined rather than imported from preview/, so a customer's
  // scan never downloads the screen registry or the preview code.
  void import("./preview/PreviewApp").then(({ PreviewApp }) => {
    createRoot(root).render(
      <StrictMode>
        <PreviewApp />
      </StrictMode>,
    );
  });
} else {
  createRoot(root).render(
    <StrictMode>
      <I18nProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </I18nProvider>
    </StrictMode>,
  );
}
